import { useTranslation } from 'react-i18next'

import { TooltipInfoWrapper } from './styles'

export const ConfidenceTooltip = () => {
	const { t } = useTranslation()

	return (
		<TooltipInfoWrapper>
			<div className="tooltip-section-title">
				{t('emissions.confidence.name', { context: 'VERY' })}
			</div>
			<div>{t('emissions.confidence.description', { context: 'VERY' })}</div>

			<div className="tooltip-section-title">
				{t('emissions.confidence.name', { context: 'SOMEWHAT' })}
			</div>
			<div>
				{t('emissions.confidence.description', { context: 'SOMEWHAT' })}
			</div>

			<div className="tooltip-section-title">
				{t('emissions.confidence.name', { context: 'NONE' })}
			</div>
			<div>{t('emissions.confidence.description', { context: 'NONE' })}</div>
		</TooltipInfoWrapper>
	)
}
